<template>
  <el-dialog
    :visible="visible"
    @close="$emit('update:visible', false)"
    width="500px"
  >
    <div
      slot="title"
      class="Diatitle"
    >
      <span>删除组织</span>
    </div>
    <Result
      title="是否确认删除组织"
      subtitle="重要提示：删除后，相关设备的数据将被清空，例如轨迹、数据报表等"
    />
    <template slot="footer">
      <el-button
        type="primary"
        plain
        size="small"
        @click="doDeleteOrganization()"
      >确定</el-button>
      <el-button
        type="info"
        plain
        size="small"
        @click="$emit('update:visible', false)"
      >取消</el-button>

    </template>
  </el-dialog>
</template>

<script>
import { mapMutations } from "vuex";
import Result from "@/components/Result/index.vue";

export default {
  components: {
    Result
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      organizationIds: null
    };
  },
  watch: {
    params(val) {
      this.organizationIds = val.organizationId;
    }
  },
  methods: {
    ...mapMutations(["COMMIT_GROUPLIST"]),
    async doDeleteOrganization() {
      try {
        const params = {
          organizationIds: this.organizationIds
        };
        const { msg } = await this.$API.delOrganization(params);
        this.$msg({
          showClose: true,
          message: msg,
          type: "success"
        });
        this.$emit("update:visible", false);

        //更新树状图数据
        const { data } = await this.$API.getOTree();
        if (Array.isArray(data)) {
          this.COMMIT_GROUPLIST(data);
        } else {
          this.COMMIT_GROUPLIST([data]);
        }
      } catch (error) {
        this.$msg({
          showClose: true,
          message: error ? error.msg : "请输入正确字段",
          type: "error"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__headerbtn {
  top: 12px !important;
}
.Diatitle {
  width: 100%;
  height: 42px;
  background-color: #f6f6f6;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  span {
    padding: 0 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
}
</style>
